import React, { FC } from 'react';
import Modal from '@common/modal';

import classnames from 'classnames/bind';
import styles from './modals.module.scss';
const cx = classnames.bind(styles);

interface PositionEndModalProps {
  visible: boolean;
  onClose: () => void;
}

const PositionEndModal: FC<PositionEndModalProps> = ({ visible, onClose }) => {
  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <em className={cx('title')}>공고를 확인할 수 없어요.</em>
        <p className={cx('desc')}>전형이 종료되거나 비공개 처리되었습니다.</p>
        <div className={cx('btnArea', 'center')}>
          <button className={cx('btn', 'check')} onClick={onClose}>
            확인
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PositionEndModal;
